import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseNotesModel from "../../models/case-notes";

export default class CaseNotesRepository extends BaseRepository {
  static modelClass = CaseNotesModel;
  modelName = "case-notes";
  defaultURLPath = "case_notes/";

  async query(params, customURLPath = null) {
    try {
      return await super.query({
        urlPath: `${customURLPath ?? this.defaultURLPath}?${qs.stringify(params)}`,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async patch(id, params) {
    try {
      if (id) {
        return await super.patch(id, params, {
          urlPath: this.defaultURLPath + id,
        });
      } else {
        throw "Note id is undefined or null";
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async createRecord(id, data) {
    try {
      if (id) {
        return await super.createRecord(data, {
          urlPathWithQueryParams: this.defaultURLPath,
        });
      } else {
        throw "Case id is undefined or null";
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
